/* tslint:disable */
/* eslint-disable */
/**
 * GLC.Portal.Api (local) Portal BFF
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { IAPCOUNTRY } from './IAPCOUNTRY';
import {
    IAPCOUNTRYFromJSON,
    IAPCOUNTRYFromJSONTyped,
    IAPCOUNTRYToJSON,
} from './IAPCOUNTRY';
import type { IAPETHNICITY } from './IAPETHNICITY';
import {
    IAPETHNICITYFromJSON,
    IAPETHNICITYFromJSONTyped,
    IAPETHNICITYToJSON,
} from './IAPETHNICITY';
import type { IAPGENDER } from './IAPGENDER';
import {
    IAPGENDERFromJSON,
    IAPGENDERFromJSONTyped,
    IAPGENDERToJSON,
} from './IAPGENDER';
import type { IAPMARITALSTATUS } from './IAPMARITALSTATUS';
import {
    IAPMARITALSTATUSFromJSON,
    IAPMARITALSTATUSFromJSONTyped,
    IAPMARITALSTATUSToJSON,
} from './IAPMARITALSTATUS';
import type { IAPNATUREOFPERSON } from './IAPNATUREOFPERSON';
import {
    IAPNATUREOFPERSONFromJSON,
    IAPNATUREOFPERSONFromJSONTyped,
    IAPNATUREOFPERSONToJSON,
} from './IAPNATUREOFPERSON';
import type { IAPTITLE } from './IAPTITLE';
import {
    IAPTITLEFromJSON,
    IAPTITLEFromJSONTyped,
    IAPTITLEToJSON,
} from './IAPTITLE';
import type { IAPYESORNO } from './IAPYESORNO';
import {
    IAPYESORNOFromJSON,
    IAPYESORNOFromJSONTyped,
    IAPYESORNOToJSON,
} from './IAPYESORNO';

/**
 * 
 * @export
 * @interface IndividualPartyDetailsViewModel
 */
export interface IndividualPartyDetailsViewModel {
    /**
     * 
     * @type {number}
     * @memberof IndividualPartyDetailsViewModel
     */
    partyId?: number;
    /**
     * 
     * @type {IAPNATUREOFPERSON}
     * @memberof IndividualPartyDetailsViewModel
     */
    natureOfPersonId?: IAPNATUREOFPERSON;
    /**
     * 
     * @type {string}
     * @memberof IndividualPartyDetailsViewModel
     */
    firstName?: string;
    /**
     * 
     * @type {string}
     * @memberof IndividualPartyDetailsViewModel
     */
    initials?: string;
    /**
     * 
     * @type {string}
     * @memberof IndividualPartyDetailsViewModel
     */
    middleName?: string;
    /**
     * 
     * @type {string}
     * @memberof IndividualPartyDetailsViewModel
     */
    surname?: string;
    /**
     * 
     * @type {string}
     * @memberof IndividualPartyDetailsViewModel
     */
    preferredName?: string;
    /**
     * 
     * @type {string}
     * @memberof IndividualPartyDetailsViewModel
     */
    previousSurname?: string;
    /**
     * 
     * @type {string}
     * @memberof IndividualPartyDetailsViewModel
     */
    identityNumber?: string;
    /**
     * 
     * @type {string}
     * @memberof IndividualPartyDetailsViewModel
     */
    passportNumber?: string;
    /**
     * 
     * @type {string}
     * @memberof IndividualPartyDetailsViewModel
     */
    popiaStatus?: string;
    /**
     * 
     * @type {Date}
     * @memberof IndividualPartyDetailsViewModel
     */
    passportExpiryDate?: Date;
    /**
     * 
     * @type {Date}
     * @memberof IndividualPartyDetailsViewModel
     */
    dateOfBirth?: Date;
    /**
     * 
     * @type {IAPTITLE}
     * @memberof IndividualPartyDetailsViewModel
     */
    titleId?: IAPTITLE;
    /**
     * 
     * @type {IAPCOUNTRY}
     * @memberof IndividualPartyDetailsViewModel
     */
    countryOfBirth?: IAPCOUNTRY;
    /**
     * 
     * @type {IAPYESORNO}
     * @memberof IndividualPartyDetailsViewModel
     */
    countryOfBirthIsSaToggle?: IAPYESORNO;
    /**
     * 
     * @type {IAPCOUNTRY}
     * @memberof IndividualPartyDetailsViewModel
     */
    countryOfResidence?: IAPCOUNTRY;
    /**
     * 
     * @type {IAPYESORNO}
     * @memberof IndividualPartyDetailsViewModel
     */
    countryOfResidenceIsSaToggle?: IAPYESORNO;
    /**
     * 
     * @type {IAPYESORNO}
     * @memberof IndividualPartyDetailsViewModel
     */
    hasSaId?: IAPYESORNO;
    /**
     * 
     * @type {IAPCOUNTRY}
     * @memberof IndividualPartyDetailsViewModel
     */
    passportCountryOfIssue?: IAPCOUNTRY;
    /**
     * 
     * @type {IAPCOUNTRY}
     * @memberof IndividualPartyDetailsViewModel
     */
    nationalityCountryId?: IAPCOUNTRY;
    /**
     * 
     * @type {IAPYESORNO}
     * @memberof IndividualPartyDetailsViewModel
     */
    nationalityCountryIsSaToggle?: IAPYESORNO;
    /**
     * 
     * @type {IAPGENDER}
     * @memberof IndividualPartyDetailsViewModel
     */
    gender?: IAPGENDER;
    /**
     * 
     * @type {IAPETHNICITY}
     * @memberof IndividualPartyDetailsViewModel
     */
    ethnicity?: IAPETHNICITY;
    /**
     * 
     * @type {IAPMARITALSTATUS}
     * @memberof IndividualPartyDetailsViewModel
     */
    maritalStatus?: IAPMARITALSTATUS;
}

/**
 * Check if a given object implements the IndividualPartyDetailsViewModel interface.
 */
export function instanceOfIndividualPartyDetailsViewModel(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function IndividualPartyDetailsViewModelFromJSON(json: any): IndividualPartyDetailsViewModel {
    return IndividualPartyDetailsViewModelFromJSONTyped(json, false);
}

export function IndividualPartyDetailsViewModelFromJSONTyped(json: any, ignoreDiscriminator: boolean): IndividualPartyDetailsViewModel {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'partyId': !exists(json, 'PartyId') ? undefined : json['PartyId'],
        'natureOfPersonId': !exists(json, 'NatureOfPersonId') ? undefined : IAPNATUREOFPERSONFromJSON(json['NatureOfPersonId']),
        'firstName': !exists(json, 'FirstName') ? undefined : json['FirstName'],
        'initials': !exists(json, 'Initials') ? undefined : json['Initials'],
        'middleName': !exists(json, 'MiddleName') ? undefined : json['MiddleName'],
        'surname': !exists(json, 'Surname') ? undefined : json['Surname'],
        'preferredName': !exists(json, 'PreferredName') ? undefined : json['PreferredName'],
        'previousSurname': !exists(json, 'PreviousSurname') ? undefined : json['PreviousSurname'],
        'identityNumber': !exists(json, 'IdentityNumber') ? undefined : json['IdentityNumber'],
        'passportNumber': !exists(json, 'PassportNumber') ? undefined : json['PassportNumber'],
        'popiaStatus': !exists(json, 'PopiaStatus') ? undefined : json['PopiaStatus'],
        'passportExpiryDate': !exists(json, 'PassportExpiryDate') ? undefined : (new Date(json['PassportExpiryDate'])),
        'dateOfBirth': !exists(json, 'DateOfBirth') ? undefined : (new Date(json['DateOfBirth'])),
        'titleId': !exists(json, 'TitleId') ? undefined : IAPTITLEFromJSON(json['TitleId']),
        'countryOfBirth': !exists(json, 'CountryOfBirth') ? undefined : IAPCOUNTRYFromJSON(json['CountryOfBirth']),
        'countryOfBirthIsSaToggle': !exists(json, 'CountryOfBirthIsSaToggle') ? undefined : IAPYESORNOFromJSON(json['CountryOfBirthIsSaToggle']),
        'countryOfResidence': !exists(json, 'CountryOfResidence') ? undefined : IAPCOUNTRYFromJSON(json['CountryOfResidence']),
        'countryOfResidenceIsSaToggle': !exists(json, 'CountryOfResidenceIsSaToggle') ? undefined : IAPYESORNOFromJSON(json['CountryOfResidenceIsSaToggle']),
        'hasSaId': !exists(json, 'HasSaId') ? undefined : IAPYESORNOFromJSON(json['HasSaId']),
        'passportCountryOfIssue': !exists(json, 'PassportCountryOfIssue') ? undefined : IAPCOUNTRYFromJSON(json['PassportCountryOfIssue']),
        'nationalityCountryId': !exists(json, 'NationalityCountryId') ? undefined : IAPCOUNTRYFromJSON(json['NationalityCountryId']),
        'nationalityCountryIsSaToggle': !exists(json, 'NationalityCountryIsSaToggle') ? undefined : IAPYESORNOFromJSON(json['NationalityCountryIsSaToggle']),
        'gender': !exists(json, 'Gender') ? undefined : IAPGENDERFromJSON(json['Gender']),
        'ethnicity': !exists(json, 'Ethnicity') ? undefined : IAPETHNICITYFromJSON(json['Ethnicity']),
        'maritalStatus': !exists(json, 'MaritalStatus') ? undefined : IAPMARITALSTATUSFromJSON(json['MaritalStatus']),
    };
}

export function IndividualPartyDetailsViewModelToJSON(value?: IndividualPartyDetailsViewModel | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'PartyId': value.partyId,
        'NatureOfPersonId': IAPNATUREOFPERSONToJSON(value.natureOfPersonId),
        'FirstName': value.firstName,
        'Initials': value.initials,
        'MiddleName': value.middleName,
        'Surname': value.surname,
        'PreferredName': value.preferredName,
        'PreviousSurname': value.previousSurname,
        'IdentityNumber': value.identityNumber,
        'PassportNumber': value.passportNumber,
        'PopiaStatus': value.popiaStatus,
        'PassportExpiryDate': value.passportExpiryDate === undefined ? undefined : (value.passportExpiryDate.toISOString()),
        'DateOfBirth': value.dateOfBirth === undefined ? undefined : (value.dateOfBirth.toISOString()),
        'TitleId': IAPTITLEToJSON(value.titleId),
        'CountryOfBirth': IAPCOUNTRYToJSON(value.countryOfBirth),
        'CountryOfBirthIsSaToggle': IAPYESORNOToJSON(value.countryOfBirthIsSaToggle),
        'CountryOfResidence': IAPCOUNTRYToJSON(value.countryOfResidence),
        'CountryOfResidenceIsSaToggle': IAPYESORNOToJSON(value.countryOfResidenceIsSaToggle),
        'HasSaId': IAPYESORNOToJSON(value.hasSaId),
        'PassportCountryOfIssue': IAPCOUNTRYToJSON(value.passportCountryOfIssue),
        'NationalityCountryId': IAPCOUNTRYToJSON(value.nationalityCountryId),
        'NationalityCountryIsSaToggle': IAPYESORNOToJSON(value.nationalityCountryIsSaToggle),
        'Gender': IAPGENDERToJSON(value.gender),
        'Ethnicity': IAPETHNICITYToJSON(value.ethnicity),
        'MaritalStatus': IAPMARITALSTATUSToJSON(value.maritalStatus),
    };
}

